import { untilDestroyed } from '@ngneat/until-destroy';
import { BehaviorSubject, Observable } from 'rxjs';
import {
  BaseDataLineageNode,
  DataLineageDiagramUIModel,
  HydratedBaseDataLineageNode,
} from '../../state/data-lineage-diagram';

export abstract class DataLineageDiagramHydrationService {
  protected readonly allTags$$ = new BehaviorSubject<string[]>([]);

  public readonly allTags$ = this.allTags$$.pipe(untilDestroyed(this));

  // private readonly hydrationNodeMap$: Observable<DataLineageHydratationNodeMap> = this.dataProvider.loading$.pipe(
  //   filter((loaded) => !!loaded),
  //   take(1),
  //   switchMap(() => this.dataProvider.items$),
  //   distinctUntilChanged((prev, curr) => isEqual(prev, curr)),
  //   throwError(() => new Error('DataLineageDiagramHydrationService fixme')) as any,
  //   // tap(([integrations, uiModels, sqlModels, visualizations, widgets, exports]) =>
  //   //   this.setTags(integrations, uiModels, sqlModels, visualizations, widgets, exports),
  //   // ),
  //   // map(([integrations, uiModels, sqlModels, visualizations, widgets, exports]) =>
  //   //   this.createHydratationNodeMap(integrations, uiModels, sqlModels, visualizations, widgets, exports),
  //   // ),
  // );

  abstract getRefLineage(assetPath: string): Observable<DataLineageDiagramUIModel>;

  abstract getAssetDependencies(
    assetPaths: string[],
  ): Observable<Array<{ mainAssetPath: string; upstream: string[]; downstream: string[] }>>;

  abstract hydrateGitNode<T extends BaseDataLineageNode>(node: T): Observable<HydratedBaseDataLineageNode<T>>;
  // return of(null as any);
  // return this.hydrationNodeMap$.pipe(
  //   map((hydrationNodeMap) => {
  //     const hydrationNode = hydrationNodeMap[node.key];

  //     return {
  //       ...node,
  //       [DataLineageNodeBinding.$Name]: node.key.split('/').at(-1) || null,
  //       [DataLineageNodeBinding.Name]: hydrationNode?.name || null,
  //       [DataLineageNodeBinding.Logo]: hydrationNode?.logo || null,
  //       [DataLineageNodeBinding.Status]: hydrationNode?.status || null,
  //       [DataLineageNodeBinding.AssetStatus]: hydrationNode?.assetStatus || null,
  //       [DataLineageNodeBinding.ItemType]: hydrationNode?.type || null,
  //       [DataLineageNodeBinding.Tags]: hydrationNode?.tags || [],
  //     };
  //   }),
  // );

  abstract hydrateGitNodes<T extends BaseDataLineageNode>(
    nodes: T[],
  ): Observable<Array<HydratedBaseDataLineageNode<T>>>;
  //   return of(null as any);
  //   // return nodes.length > 0 ? combineLatest(nodes.map((node) => this.hydrateGitNode(node))).pipe(take(1)) : of([]);
  // }

  // private createHydratationNodeMap(
  //   integrations: IntegrationUIModel[],
  //   uiModels: UiModelingUIModel[],
  //   sqlModels: SqlModelingUIModel[],
  //   dashboards: VisualizationDashboardUIModel[],
  //   widgets: VisualizationWidgetUIModel[],
  //   exports: ExportUIModel[],
  // ): DataLineageHydratationNodeMap {
  //   const hydratationNodeMap = {} as DataLineageHydratationNodeMap;

  //   integrations.forEach((integration) => {
  //     hydratationNodeMap[integration.$path] = {
  //       [DataLineageNodeBinding.Name]: integration.name,
  //       [DataLineageNodeBinding.Logo]: integration?.typeModel?.logo || null,
  //       [DataLineageNodeBinding.Status]: this.getParentStatus(integration.tables.map((t) => t.latest_job?.status)),
  //       [DataLineageNodeBinding.AssetStatus]: integration.asset_status,
  //       [DataLineageNodeBinding.Tags]: integration.tags,
  //       type: integration.typeModel?.type || null,
  //       tableCount: integration.tables.length,
  //     } as DataLineageHydratationNode;

  //     integration.tables.forEach((table) => {
  //       hydratationNodeMap[table.$path] = {
  //         [DataLineageNodeBinding.Name]: table.name,
  //         [DataLineageNodeBinding.Logo]: Y42FeatureTypeToChildLogo[Y42FeatureType.Integration],
  //         [DataLineageNodeBinding.Status]: table.latest_job?.status || null,
  //         [DataLineageNodeBinding.AssetStatus]: table.asset_status,
  //         [DataLineageNodeBinding.Tags]: table.tags,
  //       } as DataLineageHydratationNode;
  //     });
  //   });

  //   const modelHydratationFn = (model: UiModelingUIModel | SqlModelingUIModel) => {
  //     hydratationNodeMap[model.$path] = {
  //       [DataLineageNodeBinding.Name]: model.name,
  //       [DataLineageNodeBinding.Logo]: model?.typeModel?.logo || null,
  //       [DataLineageNodeBinding.Status]: this.getParentStatus(model.tables.map((t) => t.latest_job?.status)),
  //       [DataLineageNodeBinding.AssetStatus]: model.asset_status,
  //       [DataLineageNodeBinding.Tags]: model.tags,
  //       type: model?.typeModel?.type || null,
  //       tableCount: model.tables.length,
  //     } as DataLineageHydratationNode;

  //     model.tables.forEach((table) => {
  //       hydratationNodeMap[table.$path] = {
  //         [DataLineageNodeBinding.Name]: table.name,
  //         [DataLineageNodeBinding.Logo]: Y42FeatureTypeToChildLogo[Y42FeatureType.UiModel],
  //         [DataLineageNodeBinding.Status]: table.latest_job?.status || null,
  //         [DataLineageNodeBinding.AssetStatus]: table.asset_status,
  //         [DataLineageNodeBinding.Tags]: table.tags,
  //       } as DataLineageHydratationNode;
  //     });
  //   };

  //   uiModels.forEach(modelHydratationFn);
  //   sqlModels.forEach(modelHydratationFn);

  //   dashboards.forEach((dashboard) => {
  //     hydratationNodeMap[dashboard.$path] = {
  //       [DataLineageNodeBinding.Name]: dashboard.name,
  //       [DataLineageNodeBinding.Logo]: Y42FeatureTypeToLogo[Y42FeatureType.VisualizationDashboard],
  //       [DataLineageNodeBinding.AssetStatus]: dashboard.asset_status,
  //       [DataLineageNodeBinding.Tags]: dashboard.tags,
  //     } as DataLineageHydratationNode;

  //     dashboard.tabs.forEach((tab) => {
  //       hydratationNodeMap[tab.$path] = {
  //         [DataLineageNodeBinding.Name]: tab.name,
  //         [DataLineageNodeBinding.Logo]: Y42FeatureTypeToChildLogo[Y42FeatureType.VisualizationDashboard],
  //         [DataLineageNodeBinding.AssetStatus]: tab.asset_status,
  //         [DataLineageNodeBinding.Tags]: tab.tags,
  //       } as DataLineageHydratationNode;
  //     });
  //   });

  //   widgets.forEach((widget) => {
  //     hydratationNodeMap[widget.$path] = {
  //       [DataLineageNodeBinding.Name]: widget.name,
  //       [DataLineageNodeBinding.Logo]: Y42FeatureTypeToLogo[Y42FeatureType.VisualizationWidget],
  //       [DataLineageNodeBinding.AssetStatus]: widget.asset_status,
  //       [DataLineageNodeBinding.Tags]: widget.tags,
  //     } as DataLineageHydratationNode;
  //   });

  //   exports.forEach((exportItem) => {
  //     hydratationNodeMap[exportItem.$path] = {
  //       [DataLineageNodeBinding.Name]: exportItem.name,
  //       [DataLineageNodeBinding.Logo]: exportItem.typeModel.logo,
  //       [DataLineageNodeBinding.Status]: this.getParentStatus(exportItem.triggers.map((t) => t.latest_job?.status)),
  //       [DataLineageNodeBinding.AssetStatus]: exportItem.asset_status,
  //       [DataLineageNodeBinding.Tags]: exportItem.tags,
  //       type: exportItem.typeModel.type,
  //       tableCount: exportItem.triggers.length,
  //     } as DataLineageHydratationNode;

  //     exportItem.triggers.forEach((trigger) => {
  //       hydratationNodeMap[trigger.$path] = {
  //         [DataLineageNodeBinding.Name]: trigger.name,
  //         [DataLineageNodeBinding.Logo]: Y42FeatureTypeToChildLogo[Y42FeatureType.Export],
  //         [DataLineageNodeBinding.Status]: trigger.latest_job?.status || null,
  //         [DataLineageNodeBinding.AssetStatus]: trigger.asset_status,
  //         [DataLineageNodeBinding.Tags]: trigger.tags,
  //       } as DataLineageHydratationNode;
  //     });
  //   });

  //   return hydratationNodeMap;
  // }

  // private getParentStatus(childStatuses: Array<JobStatus | undefined>) {
  //   if (childStatuses.every((s) => s === JobStatus.Ready)) {
  //     return JobStatus.Ready;
  //   }

  //   if (childStatuses.some((s) => s === JobStatus.Invalid)) {
  //     return JobStatus.Invalid;
  //   }

  //   return null;
  // }

  // private setTags(
  //   integrations: IntegrationUIModel[],
  //   uiModels: UiModelingUIModel[],
  //   sqlModels: SqlModelingUIModel[],
  //   dashboards: VisualizationDashboardUIModel[],
  //   widgets: VisualizationWidgetUIModel[],
  //   exports: ExportUIModel[],
  // ) {
  //   const tags: string[][] = [];

  //   const tagsExtractionHelper = <T extends { tags: string[] }>(collection: T[]) => {
  //     collection.forEach((item) => {
  //       tags.push(item.tags);
  //     });
  //   };

  //   const datasources = [...integrations, ...uiModels, ...sqlModels];

  //   tagsExtractionHelper(datasources);
  //   tagsExtractionHelper(datasources.map((d) => d.tables).flat());

  //   tagsExtractionHelper(dashboards);
  //   tagsExtractionHelper(dashboards.map((d) => d.tabs).flat());

  //   tagsExtractionHelper(widgets);

  //   tagsExtractionHelper(exports);
  //   tagsExtractionHelper(exports.map((d) => d.triggers).flat());

  //   this.allTags$$.next([...new Set(tags.flat())]);
  // }
}
